/**
 * Slug utilities for ferry dock URLs.
 * Normalises Norwegian characters and produces URL-safe slugs.
 */

const charMap: Record<string, string> = {
  æ: 'ae', ø: 'o', å: 'a',
  Æ: 'Ae', Ø: 'O', Å: 'A',
};

export function toSlug(name: string): string {
  return name
    .trim()
    .replace(/[æøåÆØÅ]/g, (ch) => charMap[ch] ?? ch)
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-|-$/g, '');
}

export function fromSlug(slug: string): string {
  // Best-effort: lowercase first so already-uppercase inputs (e.g. 3-letter
  // upstream codes like "MOS" arriving via external URLs) get humanised
  // instead of passing through. Then replace dashes with spaces and
  // title-case each word.
  return slug
    .toLowerCase()
    .replace(/-/g, ' ')
    .replace(/\b\w/g, (c) => c.toUpperCase());
}
